import clsx from 'clsx';
import NextLink from 'next/link';
import styles from './Link.module.scss';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  title?: string;
  ariaLabel?: string;
  children: React.ReactNode;
  className?: string;
  prefetch?: boolean | null;
}

export const Link: React.FC<LinkProps> = ({
  href,
  title,
  ariaLabel,
  children,
  className,
  prefetch,
  ...props
}) => {
  // Hash-only links bypass Next.js routing so useSmoothAnchorScroll can
  // smooth-scroll without the router doing an instant scroll first.
  if (href.startsWith('#')) {
    return (
      <a
        href={href}
        title={title}
        aria-label={ariaLabel}
        {...props}
        className={clsx(styles.link, className)}
      >
        {children}
      </a>
    );
  }

  return (
    <NextLink
      href={href}
      title={title}
      aria-label={ariaLabel}
      prefetch={prefetch}
      {...props}
      className={clsx(styles.link, className)}
    >
      {children}
    </NextLink>
  );
};
